import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";
import { MdLaunch } from "react-icons/md";
import { AiOutlineClose } from "react-icons/ai";

function ProjectCards(props) {
  const [imageError, setImageError] = useState(false);
  const [showModal, setShowModal] = useState(false);

  // Barcha mavjud linklar ro'yxati
  const links = [
    {
      url: props.ghLink,
      label: "GitHub",
      icon: <BsGithub />,
      variant: "outline-light",
    },
    {
      url: props.demoLink,
      label: "Demo",
      icon: <CgWebsite />,
      variant: "primary",
    },
    {
      url: props.liveLink,
      label: "Live",
      icon: <MdLaunch />,
      variant: "success",
    },
  ].filter((link) => link.url);

  const handleImageError = () => {
    setImageError(true);
  };

  const getImageSrc = () => {
    if (imageError) {
      return "https://via.placeholder.com/300x200?text=No+Image";
    }
    return props.imgPath || "https://via.placeholder.com/300x200";
  };

  // Linklar soniga qarab grid layout
  const getButtonLayout = () => {
    const linkCount = links.length;

    if (linkCount === 0) return null;

    if (linkCount === 1) {
      return (
        <Row className="w-100 m-0">
          <Col xs={12} className="p-1">
            <Button
              href={links[0].url}
              target="_blank"
              rel="noopener noreferrer"
              variant={links[0].variant}
              className="w-100 d-flex align-items-center justify-content-center"
              style={{
                padding: "10px",
                fontSize: "0.9rem",
                borderRadius: "8px",
                transition: "all 0.3s ease",
              }}
            >
              {links[0].icon} &nbsp; {links[0].label}
            </Button>
          </Col>
        </Row>
      );
    }

    if (linkCount === 2) {
      return (
        <Row className="w-100 m-0">
          {links.map((link, index) => (
            <Col xs={6} key={index} className="p-1">
              <Button
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                variant={link.variant}
                className="w-100 d-flex align-items-center justify-content-center"
                style={{
                  padding: "8px",
                  fontSize: "0.85rem",
                  borderRadius: "6px",
                  transition: "all 0.3s ease",
                }}
              >
                {link.icon} &nbsp; {link.label}
              </Button>
            </Col>
          ))}
        </Row>
      );
    }

    // 3ta yoki ko'proq linklar uchun
    return (
      <Row className="w-100 m-0">
        {links.map((link, index) => (
          <Col xs={4} key={index} className="p-1">
            <Button
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              variant={link.variant}
              className="w-100 d-flex align-items-center justify-content-center"
              style={{
                padding: "6px",
                fontSize: "0.8rem",
                borderRadius: "5px",
                transition: "all 0.3s ease",
              }}
            >
              {link.icon}
            </Button>
          </Col>
        ))}
      </Row>
    );
  };

  return (
    <>
      <Card
        className="project-card-view"
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          background: "rgba(255, 255, 255, 0.05)",
          backdropFilter: "blur(10px)",
          borderRadius: "15px",
          overflow: "hidden",
          transition: "all 0.3s ease",
        }}
      >
        <div
          style={{
            height: "200px",
            overflow: "hidden",
            position: "relative",
            background:
              "linear-gradient(135deg, rgba(199, 112, 240, 0.1), rgba(123, 97, 255, 0.1))",
            cursor: "pointer",
          }}
          onClick={() => setShowModal(true)}
        >
          <Card.Img
            variant="top"
            src={getImageSrc()}
            alt={props.title || "project image"}
            onError={handleImageError}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
              transition: "transform 0.3s ease",
            }}
            onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
            onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
          />
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              backgroundColor: "rgba(199, 112, 240, 0.9)",
              color: "white",
              padding: "5px 10px",
              borderRadius: "5px",
              fontSize: "0.75rem",
              fontWeight: "bold",
            }}
          >
            Click to view
          </div>
        </div>

        <Card.Body
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            padding: "20px",
          }}
        >
          <Card.Title
            style={{
              textAlign: "center",
              marginBottom: "15px",
              color: "#fff",
              fontSize: "1.2rem",
              fontWeight: "600",
              cursor: "pointer",
              transition: "color 0.3s ease",
            }}
            onClick={() => setShowModal(true)}
            onMouseOver={(e) => (e.target.style.color = "#c770f0")}
            onMouseOut={(e) => (e.target.style.color = "#fff")}
          >
            {props.title}
          </Card.Title>

          {props.category && (
            <div style={{ textAlign: "center", marginBottom: "15px" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: "6px 14px",
                  backgroundColor: "rgba(199, 112, 240, 0.2)",
                  color: "#c770f0",
                  borderRadius: "20px",
                  fontSize: "0.85rem",
                  fontWeight: "500",
                  border: "1px solid rgba(199, 112, 240, 0.3)",
                }}
              >
                {props.category}
              </span>
            </div>
          )}

          <Card.Text
            style={{
              textAlign: "justify",
              flex: 1,
              color: "rgba(255, 255, 255, 0.8)",
              fontSize: "0.95rem",
              lineHeight: "1.5",
              marginBottom: "10px",
            }}
          >
            {props.description && props.description.length > 120
              ? `${props.description.substring(0, 120)}...`
              : props.description}
          </Card.Text>

          {props.description && props.description.length > 120 && (
            <div style={{ textAlign: "center", marginBottom: "15px" }}>
              <Button
                variant="link"
                onClick={() => setShowModal(true)}
                style={{
                  color: "#c770f0",
                  textDecoration: "none",
                  fontSize: "0.9rem",
                  padding: "5px 15px",
                  border: "1px solid rgba(199, 112, 240, 0.5)",
                  borderRadius: "20px",
                  transition: "all 0.3s ease",
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = "rgba(199, 112, 240, 0.2)";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Read More
              </Button>
            </div>
          )}

          {links.length > 0 && (
            <div
              style={{
                marginTop: "auto",
                width: "100%",
              }}
            >
              {getButtonLayout()}
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Modal for full project details */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.9)",
        }}
      >
        <Modal.Header
          style={{
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            border: "none",
            borderBottom: "2px solid rgba(199, 112, 240, 0.5)",
          }}
        >
          <Modal.Title style={{ color: "#c770f0", fontWeight: "bold" }}>
            {props.title}
          </Modal.Title>
          <Button
            variant="link"
            onClick={() => setShowModal(false)}
            style={{
              color: "#c770f0",
              fontSize: "1.5rem",
              textDecoration: "none",
            }}
          >
            <AiOutlineClose />
          </Button>
        </Modal.Header>

        <Modal.Body
          style={{
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            color: "#fff",
            maxHeight: "70vh",
            overflowY: "auto",
          }}
        >
          {/* Project Image */}
          <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <img
              src={getImageSrc()}
              alt={props.title}
              style={{
                width: "100%",
                maxHeight: "400px",
                objectFit: "contain",
                borderRadius: "10px",
                border: "2px solid rgba(199, 112, 240, 0.3)",
              }}
              onError={handleImageError}
            />
          </div>

          {/* Category */}
          {props.category && (
            <div style={{ marginBottom: "20px", textAlign: "center" }}>
              <Badge
                bg="dark"
                style={{
                  padding: "10px 20px",
                  fontSize: "1rem",
                  backgroundColor: "rgba(199, 112, 240, 0.3)",
                  border: "1px solid #c770f0",
                }}
              >
                {props.category}
              </Badge>
            </div>
          )}

          {/* Description */}
          <div style={{ marginBottom: "25px" }}>
            <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>
              Description
            </h5>
            <p
              style={{
                fontSize: "1rem",
                lineHeight: "1.8",
                color: "rgba(255, 255, 255, 0.9)",
                textAlign: "justify",
              }}
            >
              {props.description}
            </p>
          </div>

          {/* Tech Stack */}
          {props.techStack && props.techStack.length > 0 && (
            <div style={{ marginBottom: "25px" }}>
              <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>
                Tech Stack
              </h5>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                {props.techStack.map((tech, index) => (
                  <Badge
                    key={index}
                    bg="secondary"
                    style={{
                      padding: "8px 15px",
                      fontSize: "0.9rem",
                      backgroundColor: "rgba(123, 97, 255, 0.3)",
                      border: "1px solid rgba(123, 97, 255, 0.5)",
                      color: "#fff",
                    }}
                  >
                    {tech}
                  </Badge>
                ))}
              </div>
            </div>
          )}

          {/* Links */}
          {links.length > 0 && (
            <div>
              <h5 style={{ color: "#c770f0", marginBottom: "15px" }}>Links</h5>
              <Row>
                {links.map((link, index) => (
                  <Col
                    xs={12}
                    md={4}
                    key={index}
                    style={{ marginBottom: "10px" }}
                  >
                    <Button
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant={link.variant}
                      className="w-100"
                      style={{
                        padding: "12px",
                        fontSize: "1rem",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      {link.icon} {link.label}
                    </Button>
                  </Col>
                ))}
              </Row>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer
          style={{
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            border: "none",
            borderTop: "2px solid rgba(199, 112, 240, 0.5)",
          }}
        >
          <Button
            variant="outline-light"
            onClick={() => setShowModal(false)}
            style={{
              borderColor: "#c770f0",
              color: "#c770f0",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProjectCards;
